(ns app.front.view.licence.header
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.licence.generic-model :as gl-model]
            [app.domain.property.model :as property-model]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.separator :as ui-sep]
            [app.front.view.common.data-grid :as dg]
            [app.front.view.common.link :as common-link]
            [app.front.view.permit.download :as permit-download]
            [app.front.view.property.util :as property-util]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]))

(defn licence-category-header [permit-type category]
  (when permit-type
    (let [icon (ui/permit-type-icon permit-type)]
      [:div.flex.flew-row.content-center.items-center
       (when icon [:div.border-2.border-solid.rounded-full.mr-2.p-1 [:> icon {:class-name "block"}]])
       [:h4 category]])))

(defn licence-status
  [tr {:licence/keys [revocation-letter-document-generating? revocation-letter-document] :domain/keys [state]}]
  [dg/grid-item-tall
   (tr [:licence/status])
   [:<>
    [:div.pb-2 (tr [state])]
    (when revocation-letter-document-generating?
      [:div (cc/inline-loading {:description (tr [:licence/generating-revocation-letter-document])})])
    (when revocation-letter-document
      [file-download/download-file-link revocation-letter-document {:command :file/download-letter-file}])]])

(defn licence-issued [tr licence group-tz]
  (let [{:verdict/keys [issuer issue-date]} (:licence/verdict licence)]
    (when (and issuer issue-date)
      [dg/grid-item-tall (tr [:verdict/issue-date])
       [:div
        [:div.pb-2 ((<sub [::date-util/date-fn]) (date-util/to-tz issue-date group-tz))]
        [:div (tr [:by] [issuer])]]])))

(defn licence-data [tr {:licence/keys [valid-from valid-to id issued-to holder-names] :as licence}
                    {:keys [category primary-property lang]}]
  (let [group-tz    (-> licence :domain/authority-group :group/tz)
        format-date (<sub [::date-util/date-fn])]
    [dg/data-grid
     [licence-status tr licence]
     [dg/grid-item-tall (tr [:verdict/municipal-licence-number]) [:div id]]
     (when primary-property
       [dg/grid-item-tall
        (tr [:property/id])
        [:div>a.bx--link
         {:href (property-util/property-link primary-property)}
         (:property/id primary-property)]])
     [dg/grid-item-tall (tr [:workspace/category]) [:div category]]
     [licence-issued tr licence group-tz]
     [dg/grid-item-tall (tr [:verdict.section.type/issued-to])
      [common-link/link-or-text lang issued-to holder-names]]
     [dg/grid-item-tall (tr [:licence/valid-from]) [:div (format-date (date-util/to-tz valid-from group-tz))]]
     (when valid-to
       [dg/grid-item-tall (tr [:verdict/expiry-date]) [:div (format-date (date-util/to-tz valid-to group-tz))]])]))

(defn- licence-address-with-municipality-name
  [{:keys [tr address primary-property]}]
  (let [lang (<sub [:language])]
    (->> [(or address
              (property-model/full-address primary-property)
              (tr [:address/address-missing]))
          (property-model/municipality-name lang primary-property)]
         (remove nil?)
         (str/join ", "))))

(defn header [tr {:licence/keys [issued-to holder-names address] :as licence}]
  (let [lang             (<sub [:language])
        workspace        (gl-model/licence-issued-workspace licence)
        permit-type      (:workspace/permit-type workspace)
        category         (-> licence
                             :licence/category-group-config
                             (config-model/localized-name lang))
        primary-property (-> licence :licence/primary-property)]
    [:div.mb-8
     (when primary-property
       [licence-category-header permit-type category])
     [:div.my-2
      [:h2 (if primary-property
             (licence-address-with-municipality-name (util/mmap tr address primary-property))
             category)]]

     [:div.my-3
      [common-link/link-or-text lang issued-to holder-names]]

     [permit-download/download-button
      (util/mmap {:verdict (:licence/verdict licence)} tr)]

     [ui-sep/horizontal]

     [licence-data tr licence (util/mmap category primary-property lang)]]))
